<template>
  <div class="footer">
    <div class="footer_top">
      <div class="left_1">
        <div class="l_title">产品中心</div>
        <div class="l_text" @click="gotoPage('/product/DigitalTwinPlatform')">数字孪生平台</div>
        <div class="l_text" @click="gotoPage('/product/BIMApplication')">BIM应用</div>
        <div class="l_text" @click="gotoPage('/product/housingConstruction')">住建领域标准化数据平台</div>
      </div>
      <div class="left_2">
        <div class="l_title">定制服务</div>
        <div class="l_text" @click="gotoPage('/service/GISData')">GIS数据生产服务</div>
        <div class="l_text" @click="gotoPage('/service/BIMConsult')">BIM咨询</div>
        <div class="l_text" @click="gotoPage('/service/sceneExperience')">沉浸式场景体验</div>
      </div>
      <div class="left_3">
        <div class="l_title">解决方案</div>
        <div class="l_text" @click="gotoPage('/solution/CIMBasicPlatform')">CIM基础平台</div>
        <div class="l_text" @click="gotoPage('/solution/BIMSupervision')">BIM全过程监管</div>
        <div class="l_text" @click="gotoPage('/solution/HouseSecurity')">房屋安全管理</div>
        <div class="l_text" @click="gotoPage('/solution/estateMonitoring')">房地产监测</div>
        <div class="l_text" @click="gotoPage('/solution/publicHousing')">公房管理</div>
      </div>
      <div class="left_4">
        <div class="l_title"></div>
        <div class="l_text" @click="gotoPage('/solution/SmartAgriculture')">智慧农业</div>
        <div class="l_text" @click="gotoPage('/solution/FarmHouseSupervision')">农房监管</div>
        <div class="l_text" @click="gotoPage('/solution/ruralService')">乡村服务</div>
      </div>
      <div class="left_5">
        <div class="l_title"></div>
        <div class="l_text" @click="gotoPage('/solution/SmartLawEnforcement')">智慧执法</div>
        <div class="l_text" @click="gotoPage('/solution/SmartMunicipal')">智慧市政</div>
        <div class="l_text" @click="gotoPage('/solution/SmartTransportation')">智慧交通</div>
        <div class="l_text" @click="gotoPage('/solution/SmartCampus')">智慧校园</div>
      </div>
      <div class="left_6">
        <div class="l_title">苏州总部</div>
        <div class="l_text">
          <div class="icon_1"></div>
          <div class="t_text">189 1553 3001</div>
        </div>
        <!-- <div class="l_text">
          <div class="icon_2"></div>
          <div class="t_text">support@zhi-zai.cn</div>
        </div> -->
        <div class="l_text">
          <div class="icon_3"></div>
          <div class="t_text">中国(江苏)自由贸易试验区苏州片区苏州工业园区新平街388号塔楼C 11层</div>
        </div>
        <div class="l_stitle" style="margin-top: 20px;">泉州分部</div>
        <div class="l_text">
          <div class="icon_4"></div>
          <div class="t_text">福建省泉州市丰泽区海星街100号东海大厦B幢B1502室</div>
        </div>
      </div>
      <div class="left_7">
        <div class="title">关于我们</div>
        <img class="erweima" src="../../assets/img/footer/erweima.png" alt="" />
      </div>
    </div>
    <div class="footer_bottom">
      <p>Copyright © 2018 苏州智在云数据科技有限公司 All Rights Reserved.</p>
      <div class="footer_1">
        <img src="../../assets/img/footer/beian.png" alt="">
        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=32059002006078" rel="noreferrer" target="_blank">苏公网安备32059002006078号</a>
      </div>
      <!-- <p style="cursor: pointer; margin-top: 10px;" @click="gotoPath">苏ICP备17060741号</p> -->
      <a style="margin-top: 10px;color: #cccccc;text-decoration: none;" href="https://beian.miit.gov.cn/" rel="noreferrer" target="_blank">苏公网安备32059002006078号</a>
      <br>
      <a style="margin-top: 10px;color: #cccccc;text-decoration: none;" href="https://beian.miit.gov.cn/" rel="noreferrer" target="_blank">苏ICP备17060741号-1</a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Footer',
  components: {},
  props: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() { },
  mounted() { },
  activated() { },
  methods: {
    gotoPage(path) {
      this.$router.push(path)
    },
    gotoPath() {
      window.open('https://beian.miit.gov.cn/')
    }
  },
}
</script>
<style lang="scss" scoped>
.footer {
  background-color: #232428;

  // margin-top: 40px;
  .footer_top {
    // width: 100%;
    display: flex;
    height: 375px;

    .left_1,
    .left_2,
    .left_3,
    .left_4,
    .left_5 {
      width: 8%;
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      margin-top: 48px;
      margin-left: 5%;

      .l_title {
        width: 100%;
        height: 26px;
        font-size: 20px;
        font-family: Microsoft YaHei-Bold, Microsoft YaHei;
        font-weight: 700;
        color: #FFFFFF;
        line-height: 26px;
        margin-bottom: 48px;
      }

      .l_text {
        width: 100%;
        cursor: pointer;
        height: 18px;
        font-size: 14px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #ccc;
        line-height: 18px;
        margin-bottom: 32px;
      }
    }

    .left_4,
    .left_5 {
      margin-left: 1%;
    }

    .left_6 {
      width: 15%;
      margin-top: 48px;
      margin-left: 4%;
      display: flex;
      flex-direction: column;

      .l_title,
      .l_stitle {
        width: 100%;
        height: 26px;
        font-size: 20px;
        font-family: Microsoft YaHei-Bold, Microsoft YaHei;
        font-weight: 700;
        color: #FFFFFF;
        line-height: 26px;
        margin-bottom: 48px;
      }

      .l_stitle {
        margin-bottom: 14px;
      }

      .l_text {
        width: 100%;
        display: flex;
        height: 18px;
        font-size: 14px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #9E9E9E;
        line-height: 18px;
        margin-bottom: 32px;

        .icon_1,
        .icon_2,
        .icon_3,
        .icon_4 {
          width: 16px;
          height: 16px;
          margin-right: 24px;
          background-image: url("~@/assets/img/home/phone.png");
          background-size: 100% 100%;
        }

        .icon_2 {
          background-image: url("~@/assets/img/home/email.png");
        }

        .icon_3,
        .icon_4 {
          background-image: url("~@/assets/img/home/location.png");
        }

        .t_text {
          width: 100%;
        }
      }
    }

    .left_7 {
      margin-top: 82px;
      margin-left: 8%;

      .title {
        text-align: center;
        width: 100%;
        height: 26px;
        font-size: 20px;
        font-family: Microsoft YaHei-Bold, Microsoft YaHei;
        font-weight: 700;
        color: #FFFFFF;
        line-height: 26px;
        margin-bottom: 20px;
      }
    }
  }

  .footer_bottom {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #cccccc;
    text-align: center;
    border-top: 1px solid #3e4350;
    padding: 40px 0;
    .footer_1 {
      margin-top: 10px;
      img {
        width: 16px;
        height: 16px;
        margin-right: 5px;
      }
      a {
        color: #cccccc !important;
        // 去除下划线
        text-decoration: none!important;
      }
    }
  }
}
</style>
